<tiime-input-container
  tiimeFormInputContainer
  contentId="mission-acceptance-status-select"
  [label]="label()"
  [small]="small"
>
  <tiime-select
    id="mission-acceptance-status-select"
    [placeholder]="label()"
    [customValue]="status() | codeAndLabel: selectorData"
    (selectionChange)="emitSelectionChange($event)"
    data-cy="mission-acceptance-status-select"
  >
    <app-status [color]="status() | statusColor: statusType" tiimeSelectPrefix></app-status>

    @if (statusAt(); as statusAt) {
      <span tiimeSelectInfos>{{ '' | atBy: statusAt : statusBy()?.acronym }}</span>
    }

    @if (statusId()) {
      <app-history-infos-button
        class="show-on-hover"
        [entityType]="historyEntityType"
        [entityId]="statusId()"
        [entityTitle]="historyEntityTitle"
        [statusType]="statusType"
        tiimeSelectSuffix
      ></app-history-infos-button>
    }

    <div tiimeSelectOptions>
      @for (option of selectorData; track option.code) {
        <mat-option
          [class.mdc-list-item--selected]="option.code === status()"
          [value]="option.code"
          [disabled]="status() | disabledMissionAcceptanceStatus: option.code"
        >
          {{ option.label }}
        </mat-option>
      }
    </div>
  </tiime-select>
</tiime-input-container>
